import { NgModule } from '@angular/core';
import { PortalLinkTileComponent } from './portalLinkTile.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from '../appMaterial/app-material.module';
@NgModule({
  imports: [CommonModule, RouterModule, FlexLayoutModule.withConfig({ useColumnBasisZero: false }), AppMaterialModule],
  declarations: [PortalLinkTileComponent],
  exports: [PortalLinkTileComponent]
})
export class PortalLinkTileModule {}
